import {PayloadAction} from "@reduxjs/toolkit";
import {Dispatch} from "react";
import {Option} from "../shared/utilities/OptionT";
import {StateService} from "../service/State/StateService";

export class StateController {
    private dispatch: Dispatch<PayloadAction<any>>
    private service: StateService

    constructor(dispatch: Dispatch<PayloadAction<any>>) {
        this.dispatch = dispatch
        this.service = new StateService(this.dispatch)
    }

    public async getStates() {
        return this.service.getStates().then(res => {
            return StateController.handleResult(res)
        })
    }

    private static handleResult<T>(res: Option<T>): Option<boolean> {
        if (res?.None) {
            return {
                Some: false,
                None: res.None
            }
        }
        return {Some: true}
    }
}
